import React, { useState } from 'react';

const FILTER_GENDER_MALE = 'FILTER_GENDER_MALE'
const FILTER_GENDER_FEMALE = 'FILTER_GENDER_FEMALE'

const FILTER_SPECIALIST_UROLOGY = 'FILTER_SPECIALIST_UROLOGY'
const FILTER_SPECIALIST_NEUROLOGY = 'FILTER_SPECIALIST_NEUROLOGY'
const FILTER_SPECIALIST_DENTIST = 'FILTER_SPECIALIST_DENTIST'
const FILTER_SPECIALIST_ORTHOPEDIC = 'FILTER_SPECIALIST_ORTHOPEDIC'
const FILTER_SPECIALIST_CARDIOLOGIST = 'FILTER_SPECIALIST_CARDIOLOGIST'

const SearchFilter = (props) => {
    const initialValue = {
        gender: { male: false, female: false },
        specialist: { urology: false, neurology: false, dentist: false, orthopedic: false, cardiologist: false }
    };

    const [filter, setFilter] = useState(initialValue);

    return (
        <div className="card search-filter">
            <div className="card-header">
                <h4 className="card-title mb-0">Search Filter {props.title}</h4>
            </div>
            <div className="card-body">
                {
                    /*<div className="filter-widget">
                        <div className="cal-icon">
                            <input type="text" className="form-control datetimepicker" placeholder="Select Date" /> 
                        </div>			
                    </div>*/
                }

                <div className="filter-widget">
                    <h4>Gender</h4>
                    <div>
                        <label className="custom_check">
                            <input type="checkbox" name="gender_type" checked={filter.gender.male} onChange={e => setFilter({ ...filter, gender: { ...filter.gender, male: !filter.gender.male } })} />
                            <span className="checkmark"></span> Male Doctor
                    </label>
                    </div>
                    <div>
                        <label className="custom_check">
                            <input type="checkbox" name="gender_type" checked={filter.gender.female} onChange={e => setFilter({ ...filter, gender: { ...filter.gender, female: !filter.gender.female } })} />
                            <span className="checkmark"></span> Female Doctor
                    </label>
                    </div>
                </div>
                <div className="filter-widget">
                    <h4>Select Specialist</h4>
                    <div>
                        <label className="custom_check">
                            <input type="checkbox" name="select_specialist" checked={filter.specialist.urology} onChange={e => setFilter({ ...filter, specialist: { ...filter.specialist, urology: !filter.specialist.urology } })} />
                            <span className="checkmark"></span> Urology
                    </label>
                    </div>
                    <div>
                        <label className="custom_check">
                            <input type="checkbox" name="select_specialist" checked={filter.specialist.neurology} onChange={e => setFilter({ ...filter, specialist: { ...filter.specialist, neurology: !filter.specialist.neurology } })} />
                            <span className="checkmark"></span> Neurology
                    </label>
                    </div>
                    <div>
                        <label className="custom_check">
                            <input type="checkbox" name="select_specialist" checked={filter.specialist.dentist} onChange={e => setFilter({ ...filter, specialist: { ...filter.specialist, dentist: !filter.specialist.dentist } })} />
                            <span className="checkmark"></span> Dentist
                    </label>
                    </div>
                    <div>
                        <label className="custom_check">
                            <input type="checkbox" name="select_specialist" checked={filter.specialist.orthopedic} onChange={e => setFilter({ ...filter, specialist: { ...filter.specialist, orthopedic: !filter.specialist.orthopedic } })} />
                            <span className="checkmark"></span> Orthopedic
                    </label>
                    </div>
                    <div>
                        <label className="custom_check">
                            <input type="checkbox" name="select_specialist" checked={filter.specialist.cardiologist} onChange={e => setFilter({ ...filter, specialist: { ...filter.specialist, cardiologist: !filter.specialist.cardiologist } })} />
                            <span className="checkmark"></span> Cardiologist
                    </label>
                    </div>
                </div>
                <div className="btn-search">
                    <button type="button" className="btn btn-block" onClick={e => props.searchHandler(filter)}>Search</button>
                </div>
            </div>
        </div>
    );
}

export default SearchFilter;